import { render, staticRenderFns } from "./NavbarBottom.vue?vue&type=template&id=ce9c40c6&scoped=true"
import script from "./NavbarBottom.vue?vue&type=script&lang=js"
export * from "./NavbarBottom.vue?vue&type=script&lang=js"
import style0 from "./NavbarBottom.vue?vue&type=style&index=0&id=ce9c40c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9c40c6",
  null
  
)

export default component.exports